import { EntityReferences } from "../models/mappers";
import { EntityName } from "./entityNames";
import { AnyEntityField } from "./metadata";

export const ecommerceAddressFields = [
  "gaming_ecommaddressid", // UID
  "statecode", // Choice
  "statuscode", // Choice
  "gaming_name", // Text
  "gaming_line1", // Text
  "gaming_line2", // Text
  "gaming_city", // Text
  "gaming_stateorprovince", // Text
  "gaming_postalcode", // Text
  "gaming_telephone1", // Phone
  "gaming_primarybilltoaddress", // Choice - YesNo
  "gaming_AccountId", // Lookup - Account
  "gaming_ECommerceId", // Lookup - E-Commerce
  "gaming_CountryId", // Lookup - Country/Region
  "gaming_HubLastUpdateByContactId", // Lookup - Contact
] as const;

export const ecommerceAddressReferences: EntityReferences<EntityName.gaming_ecommaddress> = {
  [EntityName.account]: ["gaming_AccountId"],
  [EntityName.gaming_ecommerce]: ["gaming_ECommerceId"],
  [EntityName.ggp_country]: ["gaming_CountryId"],
  [EntityName.contact]: ["gaming_HubLastUpdateByContactId"],
};

export const ecommerceAddressKey: AnyEntityField<EntityName.gaming_ecommaddress> =
  "gaming_ecommaddressid";
